import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'antd';
import styled from 'styled-components/macro';

import placeHolderImage from './images/404.svg';

const MainContainer = styled.div`
  background-color: white !important;
  height: 100vh !important;
  width: 100% !important;
  background-image: none;
`;

const StyledRow = styled(Row)`
  margin: auto;
  padding: 40px;
  width: 100%;
  height: 100vh !important;
`;

const StyledCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  vertical-align: middle;
  /* height: 100%; */
`;

const ErrorPlaceholder = styled.img`
  width: 100%;
  max-height: 400px;

  @media screen and (max-width: 767px) {
    height: 200px;
  }
`;

const ErrorContentContainer = styled.div`
  margin: auto;
  height: 400px;
  justify-content: center;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 767px) {
    height: 300px;
  }
`;

const ErrorTitle = styled.span`
  color: #434e59;
  font-size: 72px;
  font-weight: 600;
  line-height: 72px;
  margin-bottom: 24px;

  @media screen and (max-width: 767px) {
    font-size: 56px !important;
    line-height: 56px;
    text-align: center;
  }
`;

const ErrorSubtitle = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 16px;
  text-align: left;

  @media screen and (max-width: 767px) {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
`;

const NotFound404 = () => {
  return (
    <MainContainer>
      <StyledRow type="flex" align="middle">
        <StyledCol span={24} md={10}>
          <ErrorPlaceholder src={placeHolderImage} alt="not-found-page" />
        </StyledCol>
        <Col span={0} md={1} />
        <StyledCol span={24} md={11}>
          <ErrorContentContainer>
            <ErrorTitle>404 Oops!</ErrorTitle>
            <ErrorSubtitle>Page not found. Looks like you're lost. Let me guide you back.</ErrorSubtitle>
            <Button type="primary" size="large" style={{ width: 'auto', margin: '0 auto' }}>
              <Link to="/">Go to Home</Link>
            </Button>
          </ErrorContentContainer>
        </StyledCol>
      </StyledRow>
    </MainContainer>
  );
};

export default NotFound404;
